/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_MetadataPropertyCreateRequest = {
    default_value?: any;
    key: string;
    label: string;
    options?: Array<string>;
    required?: boolean;
    type: models_MetadataPropertyCreateRequest.type;
};
export namespace models_MetadataPropertyCreateRequest {
    export enum type {
        STRING = 'string',
        NUMBER = 'number',
        BOOLEAN = 'boolean',
        SELECT = 'select',
    }
}

